<div class="container">
  <mat-card style="margin-top: 50px">
    <mat-card-content style="margin-left: auto; margin-right: auto">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-10">
          <section *ngIf="confirming">
            Confirming Email Address, Please Wait...
          </section>
          <section *ngIf="!confirming">
            <section *ngIf="confirmed">
              Email Address Confirmed, You May Now Login
            </section>
            <section *ngIf="!confirmed">
              Email Address Confirmation Failed
            </section>
          </section>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
